import { render, staticRenderFns } from "./lk-photos-item.vue?vue&type=template&id=b0117364&"
import script from "./lk-photos-item.vue?vue&type=script&lang=js&"
export * from "./lk-photos-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-photos-item/lk-photos-item.vue
// module id = 591
// module chunks = 0